
<template>
    <ul id="list-tasks">
      <li>
        <div id='registro'>
          <div id="headerList-check" class="checkContainer" style="width: 6%"> <input type="checkbox" @change="checkEvent"> </div>
          <div id="headerList-comprobante" class="textHeaderList" style="width: 22%">{{item.comprobante}}</div>
          <div id="headerList-tipo" class="textHeaderList" style="width: 8%">{{item.tipo}}</div>
          <div id="headerList-fecha" class="textHeaderList" style="width: 14%">{{item.fecha}}</div>
          <div id="headerList-vencimiento" class="textHeaderList" style="width: 14%">{{item.vencimiento}}</div>
          <div id="headerList-monto" class="textHeaderList" style="width: 15%">$ {{item.monto | formatMoney}}</div>
          <div id="headerList-saldo" :class="{saldoPos:item.saldo>0,saldoNeg:item.saldo<0,saldoNeutro:item.saldo==0}" style="width: 15%">$ {{item.saldo | formatMoney}}</div>
          <div id="headerList-ver" class="textHeaderList" style="width: 6%"><img id="iconVer" src="/dist/icon-ver.png" @click='btnVerDetalle'/></div>
        </div>
        <div  class="separator" style="width: 100%; height: 1px; background-color: #dddddd;" >  </div>
      </li>
    </ul>
  </template>
  

  <script>
    
    export default {
      name: 'item-cc',
      props: ['item'],
  
    //   data() {
    //     return {
    //       imagenProducto: null  
    //     }
    //   },  
  
    //   watch: {
    //     item: {
    //       immediate: true,
    //       handler  () {
    //         this.getImage()
    //       }
    //     }
    //   },

    //   computed: {
    //     getPrecioHabitual () {
    //       return this.item.PrecioHabitual.toFixed(2);
    //     },
    //     getPrecioPromocional () {
    //       return this.item.PrecioPromocional.toFixed(2);
    //     },

    //     getPedidoMinimo () {
    //       if (this.item.LimiteInferior > 0)
    //       {
    //         return this.item.LimiteInferior
    //       }
    //       else
    //       {
    //         return 'Sin limite'
    //       }          
    //     },

        // getPedidoMaximo () {
        //   if (this.item.LimiteSuperior > 0)
        //   {
        //     return this.item.LimiteSuperior
        //   }
        //   else
        //   {
        //     return 'Sin limite'
        //   }

        // }




//      },
  
      methods: {


        checkAll: function(i) {
          console.log('>>> all '+i)
        },


        checkEvent () {
          this.$emit('checkItem', this.item.id);
        },


        btnVerDetalle () {

        }
  
      },
       created: function() {
         this.$parent.$on('checkAllItems', this.checkAll);
       }
   
    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
  
  
  #registro {
   width: 650px;
   height: 50px; 
   display: flex;
   flex-direction:row; 
   align-items: center;
   justify-content: center;
   background: #ffffff; 
  }



.textHeaderList{
  color:#656E76;
  font-size: 10px;
  font-weight: 500;
}



.saldoPos{
  color:#04B590;
  font-size: 10px;
  font-weight: 500;
}

.saldoNeg{
  color:#E34860;
  font-size: 10px;
  font-weight: 500;
}

.saldoNeutro{
  color:#4969B2;
  font-size: 10px;
  font-weight: 500;
}


.checkContainer{
  display: flex;
  flex-direction:row; 
  align-items: center;
  justify-content: center;
}


#iconVer{
  width: 15px; 
  height: 15px
}


#iconVer:hover{ cursor: pointer; }

  
 </style>




// WEBPACK FOOTER //
// src/components/views/cuentaCorriente/itemCuentaCorriente.vue